const months = {
  JANUARY: 1,
  FEBRUARY: 2,
  MARCH: 3,
  APRIL: 4,
  MAY: 5,
  JUNE: 6,
  JULY: 7,
  AUGUST: 8,
  SEPTEMBER: 9,
  OCTOBER: 10,
  NOVEMBER: 11,
  DECEMBER: 12,
};

const thirtyDaysMonths = [months.APRIL, months.JUNE, months.SEPTEMBER, months.NOVEMBER];

const thirtyOneDaysMonths = [months.JANUARY, months.MARCH, months.MAY, months.JULY,
  months.AUGUST, months.OCTOBER, months.DECEMBER];

const days = {
  one: 1,
  twentyEight: 28,
  thirty: 30,
  thirtyOne: 31,
};

module.exports = { months, thirtyOneDaysMonths, thirtyDaysMonths, days };
